import React from 'react';
import {
    makeStyles,
    ListItemText,
    Box,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    image: {
        height: 70,
        width: 70
    }
}));

export default ({ alignCenter }) => {

    const classes = useStyles();

    const details = {
        company: <strong>Best Buy</strong>,
        designation: <span>Bangalore<br />Senior Software Engineer<br />(June 2026 - Present)</span>,
        imageUrl: '/static/images/bby.png',
    }

    return <Box display="flex" justifyContent={alignCenter ? 'center' : 'flex-end'} alignItems="center">
        <Box mr={2}>
            <ListItemText
                primary={details.company}
                secondary={details.designation}
            />
        </Box>
        <Box>
            <img
                alt="logo"
                className={classes.image}
                src={details.imageUrl}
            />
        </Box>
    </Box>
}
